import { useEffect, useState } from "react";
import { Input } from "./ui/input";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "./ui/alert-dialog";

// Confirmation d'une mise à la corbeille (Ordre 28) : dit ce qui va se passer et demande le motif. `target` = l'élément visé, ou null (fermé).
// `onConfirm(reason)`. Pour les tâches, DeleteTaskDialog fait la même chose avec ses propres libellés.
export default function DeleteWithReasonDialog({ target, title, description, onClose, onConfirm, testId = "delete", confirmLabel = "Mettre à la corbeille" }) {
  const [reason, setReason] = useState("");
  useEffect(() => {
    if (target) setReason("");
  }, [target]);
  const valid = reason.trim().length >= 3;
  return (
    <AlertDialog open={!!target} onOpenChange={(open) => !open && onClose()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <div className="space-y-1.5">
          <label htmlFor={`${testId}-reason`} className="text-sm font-medium text-slate-700">Motif</label>
          <Input id={`${testId}-reason`} value={reason} onChange={(e) => setReason(e.target.value)} maxLength={1000} placeholder="Pourquoi la supprimer ?" data-testid={`${testId}-reason`} />
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel>Annuler</AlertDialogCancel>
          <AlertDialogAction
            onClick={(e) => { if (!valid) { e.preventDefault(); return; } onConfirm(reason.trim()); }}
            disabled={!valid} className="bg-red-600 hover:bg-red-700" data-testid={`${testId}-confirm`}
          >
            {confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
